<div
  class="container g-0"
  *ngIf="!shouldHide && (sortByItems.length > 0 || pageSizeItems.length > 0 || languageItems.length > 0)"
>
  <div class="d-flex justify-content-end w-100">
    <app-search-utility-bar-dropdown
      *ngIf="sortByItems.length > 0"
      (choose)="changeSortBy($event.toString())"
      [items]="sortByItems"
      [defaultText]="'sortby' | translate"
      [extraClass]="'search-sort-by-dropdown'"
    ></app-search-utility-bar-dropdown>

    <app-search-utility-bar-dropdown
      class="no-mobile"
      *ngIf="pageSizeItems.length > 0"
      (choose)="changeViewSize(+$event)"
      [items]="pageSizeItems"
      [defaultText]="'view' | translate"
      [extraClass]="'search-page-size-dropdown'"
    >
    </app-search-utility-bar-dropdown>

    <app-search-utility-bar-dropdown
      *ngIf="languageItems.length > 0"
      (choose)="changeLanguage($event.toString())"
      [items]="languageItems"
      [defaultText]="'language' | translate"
      [extraClass]="'search-language-dropdown'"
    >
    </app-search-utility-bar-dropdown>
  </div>
</div>
